import useStores from 'shared/hooks/use-stores';
import { useObserver } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

type CheckoutLineItem = { type: string; value: number };

export function useCheckoutLineItems(): CheckoutLineItem[] {
  const { Cart } = useStores();
  const isCalculating: boolean = useObserver(() => Cart.isCalculating);
  const checkoutLineItems: CheckoutLineItem[] = useObserver(() => Cart.checkoutLineItems);

  const [lineItemData, setLineItemData] = useState(checkoutLineItems);

  useEffect((): void => setLineItemData(checkoutLineItems), [isCalculating, checkoutLineItems]);

  return lineItemData;
}
